import { HttpClient } from "../HttpClient";
/**
 * * Put Content
 */
export const PutContent = async (content) => {
	try {
		const { data } = await HttpClient.put("api/contents", { ...content });
		return await Promise.resolve(data);
	} catch (err) {
		return Promise.reject(err);
	}
};
